<div>
    <div class="heading">
        <h3>Claim Prioritization</h3>
        <span (click)="onNoClick()"><mat-icon>close</mat-icon></span>
     </div>
     <div class="body-user">
        <fxLayout fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px"
        style="margin-bottom: 20px;align-items: baseline;">
        <form style="width: 100%;" [formGroup]="claimPrioritizationForm">
            <mat-form-field  style="width: 100%" appearance="outline">
                <mat-label>Priority</mat-label>
                <mat-select formControlName="priority">
                    <mat-option *ngFor="let item of PriorityValue" [value]="item">{{item}}</mat-option>
                </mat-select>
                <mat-error *ngIf="claimPrioritizationForm.controls['priority'].touched && claimPrioritizationForm.controls['priority'].hasError('required')">
                This is required
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline"  style="width: 100%">
                <mat-label>Due Date</mat-label>
                <input matInput [matDatepicker]="datepicker" formControlName="dueDate" (click)="datepicker.open()" [max]="maxDate" readonly>
                <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
                <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                <mat-datepicker #datepicker>
                  <mat-datepicker-actions>
                    <button mat-button matDatepickerCancel>Cancel</button>
                    <button mat-button matDatepickerCancel class="clear" *ngIf="claimPrioritizationForm.get('dueDate')?.value" (click)="clearDate()">Clear</button>
                    <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                  </mat-datepicker-actions>
                </mat-datepicker>
              </mat-form-field>
        </form>
      </fxLayout>
      <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
        <button mat-button class="sub-button" *ngIf="!isLoading" (click)="changeClaimPriority()"><span>Set Priority</span></button>
        <button mat-button mat-dialog-close class="can-button" (click)="onNoClick()" *ngIf="!isLoading"><span>Close</span></button>
        <img src="https://cdn.elitehw.com/images/loder.gif" alt="loaderImg" width="150" height="30" class="loadimg" *ngIf="isLoading" />
    </div>
     </div>
     
</div>
